import React, { useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  Select,
  FormControl,
  Button,
  Box,
  Grid,
  Stepper,
  Step,
  StepLabel,
  Chip,
} from "@mui/material";
import axios from "axios";
import LanguageSelector from "../User/LanguageSelector";
import NotFoundPage from "../../Pages/NotFoundPage";
import { isUser } from "../../Config/isUser";
import CircularProgress from "@mui/material/CircularProgress";

const UserDetailsForm = () => {
  const [formValues, setFormValues] = useState({
    residence_city: "",
    education_status: "",
    highschool: "",
    undergraduate: "",
    masters: "",
    phd: "",
    job_status: "",
    category_of_interest: [],
    position_tags: "",
    competency_tags: "",
    languages: [],
    driver_license_status: "",
    military_status: "",
    profile_link1: "",
    profile_link2: "",
    cv_english: null,
    cv_turkish: null,
    profile_image: null,
  });

  const [activeStep, setActiveStep] = useState(0);
  const [isRegister, setIsRegister] = useState(false);
  const [loading, setLoading] = useState(false);

  const steps = ["Eğitim", "Kişisel bilgiler", "Dökümanlar"];
  const cities = [
    "Genel",
    "Adana",
    "Adıyaman",
    "Afyonkarahisar",
    "Ağrı",
    "Aksaray",
    "Amasya",
    "Ankara",
    "Antalya",
    "Ardahan",
    "Artvin",
    "Aydın",
    "Balıkesir",
    "Bartın",
    "Batman",
    "Bayburt",
    "Bilecik",
    "Bingöl",
    "Bitlis",
    "Bolu",
    "Burdur",
    "Bursa",
    "Çanakkale",
    "Çankırı",
    "Çorum",
    "Denizli",
    "Diyarbakır",
    "Düzce",
    "Edirne",
    "Elazığ",
    "Erzincan",
    "Erzurum",
    "Eskişehir",
    "Gaziantep",
    "Giresun",
    "Gümüşhane",
    "Hakkari",
    "Hatay",
    "Iğdır",
    "Isparta",
    "İstanbul",
    "İzmir",
    "Kahramanmaraş",
    "Karabük",
    "Karaman",
    "Kars",
    "Kastamonu",
    "Kayseri",
    "Kırıkkale",
    "Kırklareli",
    "Kırşehir",
    "Kilis",
    "Kocaeli",
    "Konya",
    "Kütahya",
    "Malatya",
    "Manisa",
    "Mardin",
    "Mersin",
    "Muğla",
    "Muş",
    "Nevşehir",
    "Niğde",
    "Ordu",
    "Osmaniye",
    "Rize",
    "Sakarya",
    "Samsun",
    "Siirt",
    "Sinop",
    "Sivas",
    "Şanlıurfa",
    "Şırnak",
    "Tekirdağ",
    "Tokat",
    "Trabzon",
    "Tunceli",
    "Uşak",
    "Van",
    "Yalova",
    "Yozgat",
    "Zonguldak",
  ];
  const categories = [
    "Araştırma Geliştirme (AR-GE)",
    "Geri Ödeme/Pazara Erişim",
    "Klinik Destek/Aplikasyon",
    "Kalite/Belgelendirme/Mevzuat",
    "Lojistik ve Tedarik Zinciri",
    "Pazarlama/Ürün Yönetimi",
    "Satış",
    "Teknik Servis",
    "Teknoloji Yönetimi",
    "Test/Kalibrasyon/Muayene",
    "Üretim",
    "Diğer",
  ];
  const lisans = [
    "Acıbadem Mehmet Ali Aydınlar Üniversitesi - Biyomedikal Mühendisliği",
    "Afyon Kocatepe Üniversitesi - Biyomedikal Mühendisliği",
    "Ankara Üniversitesi - Biyomedikal Mühendisliği",
    "Bahçeşehir Üniversitesi - Biyomedikal Mühendisliği",
    "Başkent Üniversitesi - Biyomedikal Mühendisliği",
    "Beykent Üniversitesi - Biyomedikal Mühendisliği",
    "Biruni Üniversitesi - Biyomedikal Mühendisliği",
    "Çukurova Üniversitesi - Biyomedikal Mühendisliği",
    "Doğu Akdeniz Üniversitesi - Biyomedikal Mühendisliği",
    "Düzce Üniversitesi - Biyomedikal Mühendisliği",
    "Erciyes Üniversitesi - Biyomedikal Mühendisliği",
    "Fatih Sultan Mehmet Vakıf Üniversitesi - Biyomedikal Mühendisliği",
    "Işık Üniversitesi - Biyomedikal Mühendisliği",
    "İnönü Üniversitesi - Biyomedikal Mühendisliği",
    "İskenderun Teknik Üniversitesi - Biyomedikal Mühendisliği",
    "İstanbul Arel Üniversitesi - Biyomedikal Mühendisliği",
    "İstanbul Medipol Üniversitesi - Biyomedikal Mühendisliği",
    "İstanbul Yeni Yüzyıl Üniversitesi - Biyomedikal Mühendisliği",
    "İstinye Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Bakırçay Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Demokrasi Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Ekonomi Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Katip Çelebi Üniversitesi - Biyomedikal Mühendisliği",
    "Karabük Üniversitesi - Biyomedikal Mühendisliği",
    "Kastamonu Üniversitesi - Biyomedikal Mühendisliği",
    "Kocaeli Üniversitesi - Biyomedikal Mühendisliği",
    "Kocaeli Üniversitesi (M.T.O.K) - Biyomedikal Mühendisliği",
    "Pamukkale Üniversitesi - Biyomedikal Mühendisliği",
    "Samsun Üniversitesi - Biyomedikal Mühendisliği",
    "Tekirdağ Namık Kemal Üniversitesi - Biyomedikal Mühendisliği",
    "TOBB Ekonomi Ve Teknoloji Üniversitesi - Biyomedikal Mühendisliği",
    "Uluslararası Kıbrıs Üniversitesi - Biyomedikal Mühendisliği",
    "Yakın Doğu Üniversitesi - Biyomedikal Mühendisliği",
    "Yeditepe Üniversitesi - Biyomedikal Mühendisliği",
    "Yıldız Teknik Üniversitesi - Biyomedikal Mühendisliği",
    "Zonguldak Bülent Ecevit Üniversitesi - Biyomedikal Mühendisliği",
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://kariyer.biyomed.net/api/users/getOneDetails",
          {
            withCredentials: true,
          },
        );
        console.log(response.data);
        setIsRegister(response.data ? true : false);
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleDocumentChange = (e, type) => {
    const file = e.target.files[0];

    if (!file) {
      alert("Lütfen bir dosya seçin!");
      return;
    }

    // Dosya boyutu kontrolü (örneğin, 5 MB sınırı)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      alert("Dosya boyutu 5MB'ı geçemez!");
      e.target.value = ""; // Dosya seçimini sıfırla
      return;
    }

    // Dosya türü kontrolü
    let allowedTypes = [];
    if (type === "cv_english" || type === "cv_turkish") {
      // CV dosyaları için sadece PDF
      allowedTypes = ["application/pdf"];
    } else if (type === "profile_image") {
      // Profil resmi için sadece resim formatları
      allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    }

    if (!allowedTypes.includes(file.type)) {
      alert("Geçersiz dosya türü! Lütfen uygun formatta bir dosya seçin.");
      e.target.value = ""; // Dosya seçimini sıfırla
      return;
    }

    // Dosyayı doğrudan state'e set et
    switch (type) {
      case "cv_english":
        setFormValues((prev) => ({
          ...prev,
          cv_english: file, // Dosyayı olduğu gibi sakla, Base64 olarak değil
        }));
        break;
      case "cv_turkish":
        setFormValues((prev) => ({
          ...prev,
          cv_turkish: file,
        }));
        break;
      case "profile_image":
        setFormValues((prev) => ({
          ...prev,
          profile_image: file,
        }));
        break;
      default:
        console.error("Bilinmeyen dosya tipi:", type);
    }
  };

  const handleRemoveDocument = (field) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [field]: null, // Dosyayı null yapıyoruz
    }));
  };
  const isValidUrl = (url) => {
    const regex = /^(https?:\/\/)?([a-z0-9.-]+)(\.[a-z]{2,})((\/[^\s]*)*)$/i;
    return regex.test(url);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (
      !formValues.residence_city ||
      !formValues.education_status ||
      !formValues.job_status ||
      !formValues.military_status ||
      !formValues.driver_license_status ||
      !formValues.languages
    ) {
      alert("Lütfen tüm zorunlu (*) ile işaretlenmiş alanları doldurun!");
      setLoading(false);
      return;
    }
    if (
      !formValues.cv_english &&
      !formValues.cv_turkish &&
      !(
        (formValues.profile_link1 &&
          formValues.profile_link1.includes("linkedin.com")) ||
        (formValues.profile_link2 &&
          formValues.profile_link2.includes("linkedin.com"))
      )
    ) {
      alert("En az 1 CV veya LinkedIn linki eklemelisiniz!");
      setLoading(false);
      return;
    }
    if (formValues.profile_link1 !== "") {
      if (!isValidUrl(formValues.profile_link1)) {
        alert("Geçerli bir link giriniz");
        setLoading(false);
        return;
      }
    }
    if (formValues.profile_link2 !== "") {
      if (!isValidUrl(formValues.profile_link2)) {
        alert("Geçerli bir link giriniz");
        setLoading(false);
        return;
      }
    }
    const formData = new FormData();
    Object.entries(formValues).forEach(([key, value]) => {
      // Append fields directly to formData, skipping the Base64 conversion
      if (value instanceof File) {
        formData.append(key, value); // Append file objects as files
      } else {
        formData.append(key, value);
      }
    });

    try {
      const response = await axios.post(
        "https://kariyer.biyomed.net/api/user/createUserDetails",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        },
      );
      console.log("Response:", response.data);
      setLoading(false);
      window.location.href = "/userprofile";
    } catch (err) {
      setLoading(false);
      console.error("Error submitting form:", err);
    }
  };

  return (
    <>
      {isUser ? (
        <div>
          {isRegister ? (
            <div
              style={{
                paddingTop: 250,
                paddingBottom: 200,
                paddingLeft: 100,
                display: "block",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p style={{ fontSize: "30px", marginTop: 10 }}>
                Bilgileriniz Başarılı bir şekilde kayıt edildi
              </p>

              <Button
                style={{
                  backgroundColor: "#23c0e9",
                  color: "black",
                  marginTop: 50,
                }}
              >
                <a href="/" style={{ color: "black", textDecoration: "none" }}>
                  Anasayfa'ya dön
                </a>
              </Button>
            </div>
          ) : (
            <Box component="form" sx={{ p: 4 }}>
              <Stepper activeStep={activeStep} sx={{ mb: 4, mt: 20 }}>
                {steps.map((label, index) => (
                  <Step key={index}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>

              {activeStep === 0 && (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <label>Eğitim durumu *</label>
                      <Select
                        name="education_status"
                        value={formValues.education_status}
                        onChange={handleInputChange}
                      >
                        <MenuItem value="Lise">Lise</MenuItem>
                        <MenuItem value="Lisans">Lisans</MenuItem>
                        <MenuItem value="Yüksek Lisans">Yüksek Lisans</MenuItem>
                        <MenuItem value="Doktora">Doktora</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Lise ve Lisans */}
                  <Grid item xs={12} sm={6}>
                    <label>Lise (Lise-İl)</label>
                    <TextField
                      fullWidth
                      label="Lise"
                      name="highschool"
                      value={formValues.highschool}
                      onChange={handleInputChange}
                      disabled={
                        formValues.education_status !== "Lise" &&
                        formValues.education_status !== "Lisans" &&
                        formValues.education_status !== "Yüksek Lisans" &&
                        formValues.education_status !== "Doktora"
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>Lisans</label>
                    <Select
                      fullWidth
                      label="Lisans"
                      name="undergraduate"
                      value={formValues.undergraduate}
                      onChange={handleInputChange}
                      disabled={
                        formValues.education_status !== "Lisans" &&
                        formValues.education_status !== "Yüksek Lisans" &&
                        formValues.education_status !== "Doktora"
                      }
                    >
                      {lisans.map((universite, index) => (
                        <MenuItem key={index} value={universite}>
                          {universite}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  {/* Yüksek Lisans ve Doktora */}
                  <Grid item xs={12} sm={6}>
                    <label>
                      Yüksek Lisans(Üniversite-Enstitü-Ana Bilim Dalı)
                    </label>
                    <TextField
                      fullWidth
                      label="Yüksek Lisans"
                      name="masters"
                      value={formValues.masters}
                      onChange={handleInputChange}
                      disabled={
                        formValues.education_status !== "Yüksek Lisans" &&
                        formValues.education_status !== "Doktora"
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>Doktora (Üniversite-Enstitü-Ana Bilim Dalı)</label>
                    <TextField
                      fullWidth
                      label="Doktora"
                      name="phd"
                      value={formValues.phd}
                      onChange={handleInputChange}
                      disabled={formValues.education_status !== "Doktora"}
                    />
                  </Grid>
                </Grid>
              )}

              {activeStep === 1 && (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <label>İkamet edilen il *</label>
                    <select
                      name="residence_city"
                      value={formValues.residence_city}
                      onChange={handleInputChange}
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                      }}
                    >
                      <option value="">İl Seçiniz</option>
                      {cities.map((city, index) => (
                        <option key={index} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <label>Çalışma durumu *</label>
                      <Select
                        name="job_status"
                        value={formValues.job_status}
                        onChange={handleInputChange}
                      >
                        <MenuItem value="Çalışıyor">Çalışıyor</MenuItem>
                        <MenuItem value="Çalışmıyor">Çalışmıyor</MenuItem>
                        <MenuItem value="Öğrenci">Öğrenci</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <label>Askerlik *</label>
                      <Select
                        name="military_status"
                        value={formValues.military_status}
                        onChange={handleInputChange}
                      >
                        <MenuItem value="Yapti">Yapti</MenuItem>
                        <MenuItem value="Tecilli">Tecilli</MenuItem>
                        <MenuItem value="Muaf">Muaf</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <label>Çalıştığı/İlgilendiği Kategori</label>
                      <Select
                        name="category_of_interest"
                        value={formValues.category_of_interest} // Virgülle ayrılmış stringi diziye çeviriyoruz
                        onChange={handleInputChange}
                        multiple // Çoklu seçim için
                        renderValue={(selected) => (
                          <Box display="flex" flexWrap="wrap" gap={0.5}>
                            {selected.map((value) => (
                              <Chip key={value} label={value} />
                            ))}
                          </Box>
                        )}
                      >
                        {categories.map((category) => (
                          <MenuItem key={category} value={category}>
                            {category}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <label>Ehliyet *</label>
                      <Select
                        name="driver_license_status"
                        value={formValues.driver_license_status}
                        onChange={handleInputChange}
                      >
                        <MenuItem value="Var">Var</MenuItem>
                        <MenuItem value="Yok">Yok</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <label>Dil *</label>
                      <LanguageSelector
                        formValues={formValues}
                        setFormValues={setFormValues}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <label>
                      Pozisyon Etiketleri(İlgilendiğiniz pozisyon adları- Örnek:
                      satış müdürü, üretim sorumlusu, mühendis)
                    </label>
                    <TextField
                      fullWidth
                      label="Pozisyon Etiketleri"
                      name="position_tags"
                      value={formValues.position_tags}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <label>
                      Yetkinlik Etiketleri(bilgi ve becerilerinizi
                      tanımlar-Örnek: iso13485, kalite kontrol, e-ihale, sağlık
                      market)
                    </label>
                    <TextField
                      fullWidth
                      label="Yetkinlik Etiketleri"
                      name="competency_tags"
                      value={formValues.competency_tags}
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>
              )}

              {activeStep === 2 && (
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <label>Profil Linki</label>
                    <TextField
                      fullWidth
                      label="Profil Linki(LinkedIn vs.) "
                      name="profile_link1"
                      value={formValues.profile_link1}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>Profil Linki 2</label>
                    <TextField
                      fullWidth
                      label="Profil Linki 2"
                      name="profile_link2"
                      value={formValues.profile_link2}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>CV İngilizce</label>
                    <div className="custom-input">
                      <span
                        style={{
                          backgroundColor: formValues.cv_english
                            ? "green"
                            : "#00b5e4",
                        }}
                      >
                        {formValues.cv_english ? (
                          <>
                            <i className="fa fa-upload" /> &nbsp;BELGE YÜKLENDİ
                          </>
                        ) : (
                          <>
                            <i className="fa fa-upload" /> &nbsp;Belge Yükle
                          </>
                        )}
                      </span>
                      <input
                        type="file"
                        name="cv_english"
                        accept=".pdf"
                        onChange={(e) => handleDocumentChange(e, "cv_english")}
                      />
                      {formValues.cv_english && (
                        <p style={{ marginLeft: "10px", fontWeight: "bold" }}>
                          {formValues.cv_english.name}
                        </p>
                      )}
                    </div>
                    {formValues.cv_english && (
                      <button
                        style={{ marginLeft: "10px", fontWeight: "bold" }}
                        onClick={() => handleRemoveDocument("cv_english")}
                      >
                        Dosyayı Sil{" "}
                        <i style={{ color: "red" }} className="fa fa-trash">
                          {" "}
                        </i>
                      </button>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <label>CV Türkçe</label>
                    <div className="custom-input">
                      <span
                        style={{
                          backgroundColor: formValues.cv_turkish
                            ? "green"
                            : "#00b5e4",
                        }}
                      >
                        {formValues.cv_turkish ? (
                          <>
                            <i className="fa fa-upload" /> &nbsp;BELGE YÜKLENDİ
                          </>
                        ) : (
                          <>
                            <i className="fa fa-upload" /> &nbsp;Belge Yükle
                          </>
                        )}
                      </span>
                      <input
                        type="file"
                        name="cv_turkish"
                        accept=".pdf"
                        onChange={(e) => handleDocumentChange(e, "cv_turkish")}
                      />
                      {formValues.cv_turkish && (
                        <p style={{ marginLeft: "10px", fontWeight: "bold" }}>
                          {formValues.cv_turkish.name}
                        </p>
                      )}
                    </div>
                    {formValues.cv_turkish && (
                      <button
                        style={{ marginLeft: "10px", fontWeight: "bold" }}
                        onClick={() => handleRemoveDocument("cv_turkish")}
                      >
                        Dosyayı Sil{" "}
                        <i style={{ color: "red" }} className="fa fa-trash">
                          {" "}
                        </i>
                      </button>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <label>Profil Resmi</label>
                    <div className="custom-input">
                      <span
                        style={{
                          backgroundColor: formValues.profile_image
                            ? "green"
                            : "#00b5e4",
                        }}
                      >
                        {formValues.profile_image ? (
                          <>
                            <i className="fa fa-upload" /> &nbsp;BELGE YÜKLENDİ
                          </>
                        ) : (
                          <>
                            <i className="fa fa-upload" /> &nbsp;Belge Yükle
                          </>
                        )}
                      </span>
                      <input
                        type="file"
                        name="profile_image"
                        accept=".jpg,.jpeg,.png"
                        onChange={(e) =>
                          handleDocumentChange(e, "profile_image")
                        }
                      />
                      {formValues.profile_image && (
                        <p style={{ marginLeft: "10px", fontWeight: "bold" }}>
                          {formValues.profile_image.name}
                        </p>
                      )}
                    </div>
                    {formValues.profile_image && (
                      <button
                        style={{ marginLeft: "10px", fontWeight: "bold" }}
                        onClick={() => handleRemoveDocument("profile_image")}
                      >
                        Dosyayı Sil{" "}
                        <i style={{ color: "red" }} className="fa fa-trash">
                          {" "}
                        </i>
                      </button>
                    )}
                  </Grid>
                </Grid>
              )}

              <Box
                sx={{ mt: 4, display: "flex", justifyContent: "space-between" }}
              >
                {/* Back button */}
                <Button
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  variant="outlined"
                >
                  GERİ
                </Button>

                {/* Next or Submit button */}
                {activeStep < steps.length - 1 ? (
                  <Button onClick={handleNext} variant="contained">
                    İLERİ
                  </Button>
                ) : (
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    disabled={loading}
                  >
                    {loading ? (
                      <CircularProgress size={24} color="inherit" />
                    ) : (
                      "Kaydet"
                    )}
                  </Button>
                )}
              </Box>
            </Box>
          )}
        </div>
      ) : (
        <NotFoundPage />
      )}
    </>
  );
};

export default UserDetailsForm;
